// extracted by mini-css-extract-plugin
export default {"wrapper":"teacher-about_wrapper__1LKSo","header":"teacher-about_header__UJ-d3","container":"teacher-about_container__9uMg5","info":"teacher-about_info__o-Drd"};